import { render, staticRenderFns } from "./EditarDispensaInex.vue?vue&type=template&id=2bd36bd4"
import script from "./EditarDispensaInex.vue?vue&type=script&lang=ts"
export * from "./EditarDispensaInex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports